import moment from 'moment/min/moment-with-locales';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment);

export const publishedDateShow =(timestamp, now)=>{
  let createdDate, currentDate;
  // if(Number(unix_timestamp?.seconds)){
  //     createdDate = new Date(unix_timestamp.seconds * 1000);
  // }else{
  //    createdDate = new Date(unix_timestamp * 1000);
  // }
  createdDate = new Date(timestamp);
  if(now){
    currentDate = now
  }else{
    currentDate = new Date();
  }
  return getDifferentDate(currentDate, createdDate)
}

export const getLocalTimeString = (createdDate) =>{
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  //const createdDateInLocal = new Date(unix_timestamp * 1000).toLocaleString('en-US', { timeZone: 'America/New_York' });
  const createdDateInLocal = createdDate.toLocaleString('en-US', { timeZone: 'America/New_York' });
  try {
    const dateContainers = createdDateInLocal.split(',')[0].split("/")
    const monthIndex = Number(dateContainers[0]) - 1;
    const month = monthNames[monthIndex]
    const day = dateContainers[1];
    const year = dateContainers[2]
    return `${month} ${day}, ${year}`
  } catch(e) {
    return createdDateInLocal;
  }
}
export const getDifferentDate =(currentDate, createdDate)=>{
    const difference = currentDate.getTime() - createdDate.getTime();
    const weeks =  Math.floor(difference / (1000 * 3600 * 24 * 7));
    const days = Math.floor(difference / (1000 * 3600 * 24));
    const hours = Math.floor(difference / (1000 * 3600));
    const minutes = Math.floor(difference / (1000 * 60));
    if(weeks < 1){
        if(days < 1){
            if(hours < 1){
                if(minutes < 1){
                  return '1 minute ago'
                }else {
                  if(minutes === 1){
                    return `${minutes} minute ago`
                  }
                  return `${minutes} minutes ago`
                }
            }else {
              if(hours === 1){
                return `${hours} hour ago`
              }
              return `${hours} hours ago`
            }
        }else{
          if(days === 1){
            return `${days} day ago`
          }
          return `${days} days ago`
        }
    }else{
      if(weeks === 1){
        return `${weeks} week ago`
      }
      if(weeks >= 3){
        return getLocalTimeString(createdDate)
      }
      return `${weeks} weeks ago`
    }
}

export const convertSecondsToMinutes = (seconds) =>{
  let minute = Math.floor(seconds / 60 )
  let second = seconds % 60
  if(second < 10){
    second = "0" + second;
  }
  if(minute === 0){
    minute = "00"
  }
  return `${minute}:${second}`
}

export const convertTimestampToString = (timestamp) =>{
   try {
        return new Date(timestamp).toISOString().slice(0, 19).replace('T', ' ')
   } catch(e) {
       return ''
   }
}

export const secondsToDuration = (seconds) => {
  if (!seconds) { return '-:--'; }
  return moment.duration(seconds, 'seconds').format('h:mm:ss', {
    stopTrim: "mm"
  });
};

export const durationToDuration= (duration) => {
  if (!duration) { return '-:--'; }
  return moment.duration(duration, 'duration').format('h:mm:ss', {
    stopTrim: "mm"
  });
};

export const timestampHumanizeFromNow = (timestamp) => {
  moment.locale(process.env.REACT_APP_DEFAULT_LOCALE);
  return moment.unix(timestamp).fromNow();
};
